import { httpClient } from "src/shared/services/httpClient";
import { AxiosResponse } from "axios";
import {
  AssigneeHistoryFilters,
  AssigneeHistoryResponse,
  AssignerHistoryFilters,
  AssignerHistoryResponse,
  OrganizationAssignee,
  SupervisorAssignee,
  SupervisorAssigner,
} from "src/supervisoryTeam/types";
import { Organization } from "src/complaint/types";

export const getSupervisorAssignees = () =>
  httpClient.get<SupervisorAssignee[]>(
    "supervisoryTeam/getSupervisorAssignees",
  );

export const getSupervisorAssigners = () =>
  httpClient.get<SupervisorAssigner[]>(
    "supervisoryTeam/getSupervisorAssigners",
  );

export const getOrganizationsByAssignee = (userId: number) =>
  httpClient.get<OrganizationAssignee[]>(
    `supervisoryTeam/getOrganizationsByAssignee?user_id=${userId}`,
  );

export const createAssignment = (data: {
  supervisorAssigneeId: number;
  organizationIds: number[];
}) => httpClient.post("supervisoryTeam/createAssignment", data);

export const getAssigneeHistory = (
  length: number,
  start: number,
  sortingData: string,
  filters?: AssigneeHistoryFilters,
): Promise<AxiosResponse<AssigneeHistoryResponse>> => {
  const formData = new FormData();
  formData.append("length", length.toString());
  formData.append("start", start.toString());
  formData.append("sortingData", sortingData);
  if (filters?.statusId !== undefined) {
    formData.append("statusId", filters.statusId.toString());
  }
  if (filters?.organizationId !== undefined) {
    formData.append("organizationId", filters.organizationId.toString());
  }
  return httpClient.post("supervisoryTeam/getAssigneeHistory", formData);
};

export const getAssignerHistory = (
  length: number,
  start: number,
  sortingData: string,
  filters?: AssignerHistoryFilters,
): Promise<AxiosResponse<AssignerHistoryResponse>> => {
  const formData = new FormData();
  formData.append("length", length.toString());
  formData.append("start", start.toString());
  formData.append("sortingData", sortingData);
  if (filters?.statusId !== undefined) {
    formData.append("statusId", filters.statusId.toString());
  }
  if (filters?.organizationId !== undefined) {
    formData.append("organizationId", filters.organizationId.toString());
  }
  if (filters?.assigneeId !== undefined) {
    formData.append("assigneeId", filters.assigneeId.toString());
  }
  if (filters?.coordinatorId !== undefined) {
    formData.append("coordinatorId", filters.coordinatorId.toString());
  }
  return httpClient.post("supervisoryTeam/getAssignerHistory", formData);
};

export const getOrganizationsForSupervisoryTeam = (): Promise<
  AxiosResponse<Organization[]>
> => httpClient.get("supervisoryTeam/getOrganizationsForSupervisoryTeam");

export const getOrganizationsForAssignerFilters = (): Promise<
  AxiosResponse<Organization[]>
> => httpClient.get("supervisoryTeam/getOrganizationsForAssignerFilters");

export const getOrganizationsForAssigneeHistoryFilters = (): Promise<
  AxiosResponse<Organization[]>
> =>
  httpClient.get("supervisoryTeam/getOrganizationsForAssigneeHistoryFilters");

export const getActiveOrganizationsForAssignee = (): Promise<
  AxiosResponse<Organization[]>
> => httpClient.get("supervisoryTeam/getActiveOrganizationsForAssignee");

export const appealAssignment = ({ assignmentId }: { assignmentId: number }) =>
  httpClient.post("supervisoryTeam/appealAssignment", { assignmentId });
